<template>
  <!-- 我要加入 -->
  <div class="index-container">
    <bannerImg bannerText="我要加入" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="back-img" :style="{ backgroundImage: 'url( ' + backImg + ')' }">
          <div class="b-title">关于柏瑞康</div>
          <div
            class="b-words"
          >柏瑞康主要为学习者提供海量、优质的课程，课程结构严谨，用户可以根据自身的学习程度，自主安排学习进度。云课堂的宗旨是，为每一位想真真正正学到些实用知识、技能的学习者，提供贴心的一站式学习服务。</div>
          <div
            class="b-words"
          >立足于实用性的要求，云课堂精选各类课程，与多家权威教育、培训机构建立合作，课程数量已达10000+，课时总数超100000，涵盖实用软件、IT与互联网、外语学习、生活家居、兴趣爱好、职场技能、金融管理、考试认证、中小学、亲子教育等十余大门类，其中不乏数量可观、制作精良的独家课程。从用户生活、职业、娱乐等多个维度，为用户打造实用学习平台。</div>
          <div class="b-words">Online Education目前拥有Web端，移动端(Android、iOS)正在开发中</div>
        </div>
        <div class="join-box">
          <el-input placeholder="请填写您的姓名" v-model="info.username"></el-input>
          <el-input placeholder="请填写您的联系方式" v-model="info.mobile"></el-input>
          <el-input type="textarea" :rows="4" placeholder="请填写您的留言内容" v-model="info.remark"></el-input>
          <div class="submit-button" @click="joinUs">立即提交</div>
        </div>
      </div>
    </personalSidebar>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import backImg from '@/assets/img/joinUs.png';
import api from '../api/api';
const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
export default {
  name: 'joinUs',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      backImg: backImg,
      info: {
        username: '',
        mobile: '',
        remark: ''
      }
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    joinUs() {
      if (!this.info.username) {
        this.$message.warning('请输入您的姓名！');
      } else if (!this.info.mobile) {
        this.$message.warning('请输入您的电话！');
      } else if (!phoneReg.test(this.info.mobile)) {
        this.$message.warning('电话格式不正确，请重新输入！');
      } else if (!this.info.remark) {
        this.$message.warning('请输入您的留言！');
      } else {
        api.joinUs(this.info).then(res => {
          if (res.result) {
            this.$message.success('留言成功!');
            Object.keys(this.info).forEach(key => (this.info[key] = ''));
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
}
.back-img {
  width: 100%;
  //   height: 358PX;
  padding: 42PX 62PX 8PX 84PX;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  .b-title {
    padding-bottom: 22PX;
    font-size: 20PX;
    color: #ffffff;
  }
  .b-words {
    padding-bottom: 20PX;
    font-size: 16PX;
    color: #ffffff;
    text-shadow: 0PX 2PX 8PX rgba(0, 0, 0, 0.5);
  }
}
.join-box {
  padding: 56PX 0 60PX 0;
}
.submit-button {
  width: 34%;
  margin: 64PX auto 60PX;
  font-size: 18PX;
  color: #ffffff;
  line-height: 64PX;
  text-align: center;
  border-radius: 45PX;
  background-color: #f1a475;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
/deep/ {
  .el-input,
  .el-textarea {
    display: block;
    width: 38%;
    margin: 0 auto 24PX;
  }
  .el-input__inner {
    border-radius: 27PX;
    border-color: #dddddd;
  }
  .el-textarea__inner {
    border-radius: 5PX;
    border-color: #dddddd;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/joinUs.vue